// removed by extract-text-webpack-plugin
module.exports = {"root":"video-hero__root","isSticky":"video-hero__isSticky","content":"video-hero__content","playerContainer":"video-hero__playerContainer","videoPlayer":"video-hero__videoPlayer","tveProvider":"video-hero__tveProvider","side":"video-hero__side","rightAdContainer":"video-hero__rightAdContainer","hasVideo":"video-hero__hasVideo","ad":"video-hero__ad","rightAd":"video-hero__rightAd video-hero__ad","dfpAd":"video-hero__dfpAd video-hero__rightAd video-hero__ad","fwAd":"video-hero__fwAd video-hero__rightAd video-hero__ad"};


//////////////////
// WEBPACK FOOTER
// ./src/show-page/components/video-hero/styles.less
// module id = 497
// module chunks = 1